import {post} from "../API/cloudFunctions";
import firebase from "firebase";

export default class Device {


  constructor( location, name, type, uid, maintenance, softwareversion, hwversion, hwidentification, typesensor, listsensor, lastupdate) {
    this.location = location;
    this.name = name;
    this.type = type;
    this.uid = uid;
    this.maintenance = maintenance;
    this.softwareversion = softwareversion;
    this.hwversion = hwversion;
    this.hwidentification = hwidentification;
    this.typesensor = typesensor;
    this.listsensor = listsensor;
    this.lastupdate = lastupdate;
  }

  updateDevice() {
    console.log('update Device')

    let device = {
      id: this.id,
      updates: {
        name: this.name,
        location: this.location,
        type: this.type,
        maintenance: this.maintenance,
        softwareversion: this.softwareversion,
        hwversion: this.hwversion,
        hwidentification: this.hwidentification,
        typesensor: this.typesensor,
        listsensor: this.listsensor,
        lastupdate: this.lastupdate,

      }
    }

    console.log('al ', device)
    return new Promise((resolve, reject) => {

      post('updateDevice', device).then(success => {
        console.log("Device updated with success")
        console.log(success)
        resolve(success)
      }).catch(error => {
        console.error('failed to update')
        console.error('error', error)
        reject(error)
      })
    })

  }
// FIXME: DELETE THIS IF NOT NEEDED
  static getDeviceList() {
    console.log('get Device Function')
    //console.log('in DEviceJs user '+user)
    let al = {
      data: {}
    }
    return new Promise((resolve, reject) => {
      post('getDeviceList').then(success => {
        resolve(success)

      }).catch(error => {
        console.log()
        reject(error)
      })
    })
  }

//addDevice to the datastore
  addDevice() {
    console.log('******************************* In ADD Device *******************************')

    let al = {
      id: this.id,
      data: {
        name: this.Name,
        location: this.Location,
        type: this.Type
      }
    };
    return new Promise((resolve, reject) => {

      post('addDevice', al).then(success => {
        console.log("Device sent with success")
        console.log(success)
        console.log('******************************* Out Of ADD Device *******************************')

        resolve(success)
      }).catch(error => {
        console.error('failed to send Device')
        console.error('error', error)
        reject(error)
        console.log('******************************* Out Of ADD Device *******************************')

      })

    })

  }
}



// WEBPACK FOOTER //
// ./src/Class/Device.js